import { InjectionToken, inject } from '@angular/core';
import { IContactStore } from './contact.public';
import { ContactStore } from './contact.store';

export const CONTACT_STORE = new InjectionToken<IContactStore>(
    'CONTACT_STORE',
    {
        providedIn: 'root',
        factory: () => inject(ContactStore) as IContactStore,
    },
);
